(() => {
  function init(root) {
    if (root.dataset.galleryReady) return;
    root.dataset.galleryReady = 'true';
    const slides = [...root.querySelectorAll('.gallery-item')];
    if (!slides.length) return;
    const thumbs = [...root.querySelectorAll('[data-thumbnail]')];
    const stage = root.querySelector('.gallery-stage');
    const dialog = root.querySelector('dialog');
    let index = Math.max(0, slides.findIndex(slide => !slide.hidden));
    let opener;
    function show(next, scroll = true) {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        slide.hidden = i !== index;
        if (slide.hidden) {
          slide.querySelectorAll('video').forEach(video => video.pause());
          slide.querySelectorAll('iframe').forEach(frame => { if (frame.dataset.playing === 'true') frame.src = frame.src; frame.dataset.playing = 'false'; });
        } else slide.querySelectorAll('iframe').forEach(frame => { frame.dataset.playing = 'true'; });
      });
      thumbs.forEach(thumb => thumb.setAttribute('aria-pressed', String(thumb.dataset.thumbnail === slides[index].dataset.mediaId)));
      if (scroll) thumbs[index]?.scrollIntoView({block: 'nearest', inline: 'nearest'});
      root.querySelector('[data-gallery-status]').textContent = `${index + 1} / ${slides.length}`;
    }
    root.querySelectorAll('[data-gallery-step]').forEach(button => button.addEventListener('click', () => show(index + Number(button.dataset.galleryStep))));
    thumbs.forEach(button => button.addEventListener('click', () => show(slides.findIndex(slide => slide.dataset.mediaId === button.dataset.thumbnail))));
    root.addEventListener('gallery:select', event => { const next = slides.findIndex(slide => slide.dataset.mediaId === event.detail); if (next >= 0) show(next); });
    stage.addEventListener('keydown', event => {
      if (event.target.closest('video,iframe,model-viewer')) return;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); show(index + (event.key === 'ArrowRight' ? 1 : -1)); }
    });
    let start;
    stage.addEventListener('touchstart', event => { start = event.touches.length === 1 ? {x:event.touches[0].clientX,y:event.touches[0].clientY} : null; }, {passive:true});
    stage.addEventListener('touchend', event => { if (!start) return; const touch = event.changedTouches[0]; const dx = touch.clientX-start.x, dy = touch.clientY-start.y; if (Math.abs(dx)>50 && Math.abs(dx)>Math.abs(dy)*1.5 && !event.target.closest('video,iframe,model-viewer')) show(index+(dx<0?1:-1)); start=null; }, {passive:true});
    root.querySelectorAll('[data-full-image]').forEach(button => button.addEventListener('click', () => {
      if (typeof dialog.showModal !== 'function') { window.open(button.dataset.fullImage, '_blank', 'noopener'); return; }
      opener=button; const image=dialog.querySelector('img'); image.src=button.dataset.fullImage; image.alt=button.querySelector('img').alt; dialog.showModal();
    }));
    dialog.querySelector('.gallery-close').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if(event.target===dialog) dialog.close(); });
    dialog.addEventListener('close', () => opener?.focus());
    show(index, false);
    // Warm up: once the first photo is in, fetch the hidden photos in the background so clicks feel instant.
    const warm = () => root.querySelectorAll('img[loading="lazy"]').forEach(img => { img.loading = 'eager'; });
    if (document.readyState === 'complete') setTimeout(warm, 300);
    else window.addEventListener('load', () => setTimeout(warm, 300), {once: true});
  }
  document.querySelectorAll('[data-gallery]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-gallery]').forEach(init));
})();
